export const GET_DASHBOARD_CANCELLED_TASKS = 'GET_DASHBOARD_CANCELLED_TASKS';
export const GET_DASHBOARD_CANCELLED_TASKS_SUCCESS = 'GET_DASHBOARD_CANCELLED_TASKS_SUCCESS';
export const GET_DASHBOARD_CANCELLED_TASKS_ERROR = 'GET_DASHBOARD_CANCELLED_TASKS_ERROR';
